// extracted by mini-css-extract-plugin
module.exports = {"off-grid-C":"C_off-grid-C__X7wcW"};